<template>
    <div id="project" style="height:100%;">
        <el-row>
            <el-col :span="24">
                <el-collapse v-model="activeName" style="margin-bottom:15px;">
                    <el-collapse-item title="操作面板" name="1">
                        <div class="t-op__container">
                            <div class="t-op__item btn__ction">
                                <el-button type="primary" icon="el-icon-circle-plus" @click="handleAdd">添加</el-button>
                            </div>
                            <div class="t-op__item filter__action">
                                <div class="search-item-progress">
                                    <el-col :span="4" style="text-align: right;">
                                        <span class="progress-label">进度：</span>
                                    </el-col>
                                    <el-col :span="8" :offset="2">
                                        <span>从</span>
                                        <el-slider v-model="progressStart" :max="1" :min="0" :step="0.01"
                                                   :format-tooltip="formatTooltip">
                                        </el-slider>
                                    </el-col>
                                    <el-col  :span="8" :offset="2" >
                                        <span>至</span>
                                        <el-slider v-model="progressEnd" :max="1" :min="0" :step="0.01"
                                                   :format-tooltip="formatTooltip">
                                        </el-slider>
                                    </el-col>
                                </div>
                                <div class="search-item-project">
                                    <el-select class="item project" filterable clearable v-model="projectId"
                                               placeholder="请选择项目">
                                        <el-option
                                                v-for="item in projects"
                                                :key="item.id"
                                                :label="item.projectName"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-button icon="el-icon-search" class="search" @click="loadData"></el-button>
                                </div>

                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table
                        v-loading="loading"
                        :data="tableData"
                        width="100%"
                        :height="tableHeight"
                        stripe>
                    <el-table-column
                            label="序号"
                            type="index"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            show-overflow-tooltip
                            label="客户名称"
                            prop="customerName"
                            min-width="180"
                            :formatter="fmtCustomerId">
                    </el-table-column>
                    <el-table-column
                            show-overflow-tooltip
                            label="项目名称"
                            prop="projectName"
                            min-width="130">
                    </el-table-column>
                    <el-table-column
                            label="签约"
                            prop="signStatus"
                            min-width="120"
                            :filters="editItem.signStatusList"
                            :filter-method="filterSignStatus">
                    </el-table-column>
                    <el-table-column
                            label="阶段"
                            prop="stage"
                            min-width="130"
                            :filters="editItem.stageList"
                            :filter-method="filterStageStatus">
                    </el-table-column>
                    <el-table-column
                            label="完成比例"
                            prop="progressNow"
                            min-width="150"
                            :formatter="fmtProgress">
                    </el-table-column>
                    <el-table-column
                            label="负责人"
                            prop="leaderName"
                            min-width="120"
                            :formatter="fmtLeader">
                    </el-table-column>
<!--                    <el-table-column show-overflow-tooltip-->
<!--                                     label="参与人员"-->
<!--                                     min-width="200">-->
<!--                          <template slot-scope="scope">-->
<!--                               {{ fmtJoinUsers(scope.row) }}-->
<!--                          </template>-->
<!--                    </el-table-column>-->
                    <el-table-column
                            label="约定开始时间"
                            prop="appointCreateTime"
                            min-width="180"
                            :formatter="fmtJsDate">
                    </el-table-column>
                    <el-table-column
                            label="约定结束时间"
                            prop="appointEndTime"
                            min-width="180"
                            :formatter="fmtJsDate">
                    </el-table-column>
                    <el-table-column
                            label="实际开始时间"
                            prop="realCreateTime"
                            min-width="180"
                            :formatter="fmtJsDate">
                    </el-table-column>
                    <el-table-column
                            label="实际结束时间"
                            prop="realEndTime"
                            min-width="180"
                            :formatter="fmtJsDate">
                    </el-table-column>
                    <el-table-column
                            label="标准UT量"
                            prop="consumption"
                            min-width="150">
                    </el-table-column>
                    <el-table-column
                            width="180"
                            label="预估总成本"
                            prop="predictCost"
                            :formatter="fmtMoney">
                    </el-table-column>
                    <el-table-column
                            width="180"
                            label="其他成本"
                            prop="otherCost"
                            :formatter="fmtOtherCost">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">修改
                            </el-button>
                            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :hide-on-single-page="value"
                        style="padding:10px 0px;"
                        :page-size="pageSize"
                        :total="total"
                        :current-page="pageIndex"
                        @current-change="onCurrentChange">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="editItem.title" :width="editItem.width" :visible.sync="editItem.visible">

            <el-form :model="editItem.data">
                <el-form-item label="客户名称" label-width="150px">
                    <el-select class="input-with-select" v-model="editItem.data.customerId" placeholder="请选择">
                        <el-option
                                v-for="item in editItem.customerList"
                                :key="item.id"
                                :label="item.customer"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目名称" label-width="150px">
                    <el-input v-model="editItem.data.projectName" autocomplete="off" clearable></el-input>
                </el-form-item>
                <el-form-item label="是否签约" label-width="150px">
                    <el-select v-model="editItem.data.signStatus" placeholder="请选择">
                        <el-option
                                v-for="item in editItem.signStatusList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="阶段" label-width="150px">
                    <el-select v-model="editItem.data.stage" placeholder="请选择">
                        <el-option
                                v-for="item in editItem.stageList"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="约定开始-结束时间" label-width="150px">
                    <el-date-picker
                            width="200px"
                            v-model="appointDateRange"
                            @change="appointDateRangeChange"
                            type="daterange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="完成比例" label-width="150px">
                    <el-slider v-model="editItem.data.progressNow"
                               :max="1" :min="0" :format-tooltip="formatTooltip" disabled>
                    </el-slider>
                </el-form-item>
                <el-form-item label="项目负责人" label-width="150px">
                    <el-select class="input-with-select" v-model="editItem.data.leaderId" :filterable="editItem.filter"
                               placeholder="请选择">
                        <el-option
                                v-for="item in editItem.userList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="参与人员" label-width="150px">
                    <el-row>
                        <el-col :span="24">
                            <el-table
                                    fit
                                    style="width:100%"
                                    :data="editItem.joinUsers"
                                    border
                                    show-summary
                                    :summary-method="getSummaries">
                                <el-table-column
                                        width="80px"
                                        type="index"
                                        label="序号">
                                </el-table-column>
                                <el-table-column
                                        width="150px"
                                        prop="userName"
                                        label="员工姓名">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.userId" :filterable="editItem.filter"
                                                   placeholder="请选择" @change="handleChange">
                                            <el-option-group v-for="group in joinUserOptions"
                                                             :key="group.label"
                                                             :label="group.label">
                                                <el-option
                                                        v-for="item in group.options"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-option-group>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="initWork"
                                        label="分配工作量(天)">
                                    <template slot-scope="scope">
                                        <el-input-number v-model="scope.row.initWork"
                                                         :step="1"
                                                         :min="0"
                                                         @change="handleChange">
                                        </el-input-number>
                                        <el-checkbox class="el-input-number" v-if="scope.row.initWork===0"
                                                     v-model="scope.row.noDateLimit">
                                            无日期限制
                                        </el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        width="150px"
                                        prop="cost"
                                        label="合算薪酬(元)">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.cost }}</span>
                                        <i class="el-icon-delete" style="cursor: pointer;"
                                           @click="handleJoinDataDel(scope.row.index)"></i>
                                    </template>

                                </el-table-column>
                            </el-table>

                            <el-button style="margin-top:10px;" type="primary" icon="el-icon-circle-plus"
                                       @click="handleJoinData">添加参与人员
                            </el-button>

                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="其它成本" label-width="150px">
                    <el-row>
                        <el-col :span="24">
                            <el-table
                                    fit
                                    style="width:100%"
                                    :data="editItem.otherCost"
                                    border
                                    show-summary
                                    :summary-method="getOtherCostSummaries">
                                <el-table-column
                                        type="index"
                                        label="序号"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="itemName"
                                        label="成本项描述">
                                    <template slot-scope="scope">
                                        <el-input type="textarea" v-model="scope.row.itemName"
                                                  autocomplete="off"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="cost"
                                        label="花费金额(元)">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.cost" class="w-100" type="number"
                                                  autocomplete="off"
                                                  @change="handleChange">
                                        </el-input>
                                        <i style="cursor: pointer;" class="el-icon-delete"
                                           @click="handleOtherCostDel(scope.row.index)"></i>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-button style="margin-top:10px;" type="primary" icon="el-icon-circle-plus"
                                       @click="handleOtherCost">添加其它成本
                            </el-button>

                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item label="标准UT量" label-width="150px">
                    <el-input disabled v-model="editItem.data.consumption" autocomplete="off">
                        <template slot="append">人天</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="预估成本" label-width="150px">
                    <el-input disabled v-model="editItem.data.predictCost" autocomplete="off">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="editItem.visible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    export default {
        name: "ProjectManage",
        data() {
            return {
                loading: true,
                tableHeight: window.innerHeight * 0.70,
                editItem: {
                    width: '60%',
                    visible: false,
                    title: '项目信息',
                    data: {
                        appointCreateTime: '',
                        appointEndTime: '',
                        realCreateTime: '',
                        realEndTime: '',
                        consumption: 0,
                        customerId: '',
                        customerName: '',
                        stage: '',
                        id: 0,
                        signStatus: '',
                        leaderId: '',
                        leaderName: '',
                        joinUsersJSON: '',
                        joinUsers: [],
                        projectName: '',
                        progressNow: 0,
                        predictCost: 0,
                        createTime: '',
                        createBy: '',
                        modifyTime: '',
                        modifyBy: '',
                        appointDateRange: '',
                        realDateRange: ''
                    },
                    joinUsers: [],
                    otherCost: [{
                        itemName: '',
                        cost: 0
                    }],
                    levelList: [],
                    userList: [],
                    groupList: [{
                        id: -1,
                        name: '所有人员'
                    }, {
                        id: -2,
                        name: '所有内部人员'
                    }, {
                        id: -3,
                        name: '所有外包人员'
                    }],
                    customerList: [],
                    userProjectMapList: [],
                    stageList: [{text: '实施阶段', value: '实施阶段'}, {text: '售前阶段', value: '售前阶段'}
                        , {text: '已经关闭', value: '已经关闭'}, {text: '需求确认', value: '需求确认'}
                        , {text: 'UAT阶段', value: 'UAT阶段'}, {text: '维保阶段', value: '维保阶段'}
                        , {text: '无', value: '无'}],
                    signStatusList: [{text: '已签约', value: '已签约'}, {text: '已关闭', value: '已关闭'}
                        , {text: '未签约', value: '未签约'}, {text: '无', value: '无'}],
                    isAdd: false,
                    filter: true,
                },
                activeName: ['1'],
                tableData: [],
                search: '',
                progressStart:0,
                progressEnd:1,
                value: false,
                pageIndex: 1,
                pageSize: 20,
                total: 0,
                rules: [],
                projects: [],
                projectId: ''

            }
        },
        methods: {
            fmtJoinUsers(row) {

            },
            filterSignStatus(value, row) {
                return row.signStatus === value
            },
            filterStageStatus(value, row) {
                return row.stage === value
            },
            fmtJsDate(row, column) {
                if (column.property === 'appointCreateTime') {
                    if (!row.appointCreateTime) {
                        return ''
                    } else {
                        return new Date(row.appointCreateTime).Format("yyyy-MM-dd")
                    }
                }
                if (column.property === 'appointEndTime') {
                    if (!row.appointEndTime) {
                        return ''
                    } else {
                        return new Date(row.appointEndTime).Format("yyyy-MM-dd")
                    }
                }
                if (column.property === 'realCreateTime') {
                    if (!row.realCreateTime) {
                        return ''
                    } else {
                        return new Date(row.realCreateTime).Format("yyyy-MM-dd")
                    }
                }
                if (column.property === 'realEndTime') {
                    if (!row.realEndTime) {
                        return ''
                    } else {
                        return new Date(row.realEndTime).Format("yyyy-MM-dd")
                    }
                }
            },
            fmtProgress(row, column) {
                return (row.progressNow * 100).toFixed(0) + '%'
            },
            formatTooltip(val) {
                return (val * 100).toFixed(0) + "%"
            },
            fmtLeader(row, column) {
                let user = this.editItem.userList.find(v => v.id == row.leaderId)
                if (user) {
                    return user.name
                }
                return ''
            },
            fmtUserId(row, column) {
                let user = this.editItem.userList.find(v => v.id == row.leaderId)
                if (user) {
                    return user.name
                }
                return ''
            },
            fmtCustomerId(row, column) {
                let customer = this.editItem.customerList.find(v => v.id == row.customerId)
                if (customer) {
                    return customer.customer
                }
                return ''
            },
            fmtMoney(row, column) {
                return "￥" + row.predictCost
            },
            fmtOtherCost(row, column) {
                try {
                    const otherJson = JSON.parse(row.otherCost)
                    if (otherJson) {
                        let sum = 0
                        for (let i = 0; i < otherJson.length; i++) {
                            sum += Math.round(parseFloat(otherJson[i].cost))
                        }
                        return "￥" + sum;
                    }
                } catch (e) {
                }
                return 0
            },
            initJoinUser() {
                if (this.editItem.joinUsers.length == 0) {
                    this.pushNewItemToJoinUserData()
                }
            },
            initOtherCost() {
                if (!this.editItem.otherCost || this.editItem.otherCost.length == 0) {
                    this.pushNewItemToOtherData()
                }
            },
            pushNewItemToJoinUserData() {
                const index = this.editItem.joinUsers.length == 0 ? 0 : this.editItem.joinUsers.length
                const obj = {
                    index: index,
                    userId: '',
                    userName: '',
                    initWork: '',
                    projectId: this.editItem.data.id,
                    projectName: this.editItem.data.projectName,
                    noDateLimit: true
                }
                this.editItem.joinUsers.push(obj)
                //绑定数据
                this.$set(this.editItem.joinUsers
                    , index
                    , obj)
            },
            pushNewItemToOtherData() {
                const index = this.editItem.otherCost.length == 0 ? 0 : this.editItem.otherCost.length
                const obj = {
                    index: index,
                    itemName: '',
                    cost: 0
                }
                this.editItem.otherCost.push(obj)
                //绑定数据
                this.$set(this.editItem.otherCost
                    , index
                    , obj)
            },

            handleAdd() {
                this.editItem.data = {}
                this.editItem.joinUsers = []
                this.editItem.otherCost = []
                this.editItem.title = '添加项目'
                this.editItem.visible = true
                this.editItem.isAdd = true

                this.initJoinUser()
            },
            handleEdit(index, row) {
                console.log(index, row);
                this.editItem.title = '编辑项目'
                this.editItem.visible = true
                this.editItem.data = row;

                if (row.maps) {
                    this.editItem.joinUsers = row.maps
                } else {
                    this.editItem.joinUsers = []
                }

                if (this.editItem.joinUsers && this.editItem.joinUsers.length > 0) {
                    for (let i = 0; i < this.editItem.joinUsers.length; i++) {
                        this.editItem.joinUsers[i].index = i
                    }
                }

                this.editItem.isAdd = false

                try {
                    if (row.otherCost) {
                        this.editItem.otherCost = JSON.parse(row.otherCost)

                        this.$set(this.editItem, 'otherCost', JSON.parse(row.otherCost))
                    }
                } catch (e) {
                    this.editItem.otherCost = []
                }

                this.autoLoadEditJoinUsers()

                this.calcProjectCost()

                this.editItem.data.appointDateRange = []
                if (this.editItem.data.appointCreateTime) {
                    this.editItem.data.appointDateRange.push(this.editItem.data.appointCreateTime)
                }
                if (this.editItem.data.appointEndTime) {
                    this.editItem.data.appointDateRange.push(this.editItem.data.appointEndTime)
                }
            },
            handleDelete(index, row) {
                this.$confirm('确认删除吗?', '提示').then(() => {
                    this.$store.dispatch("project/deleteProject", row.id)
                        .then(response => {
                            if (response && response.data.code === 200) {
                                this.pageIndex = 1
                                this.loadData()
                            } else {
                                this.$message({
                                    message: response.data.message,
                                    type: 'error'
                                })
                            }
                        })

                }).catch(() => {
                })
            },
            loadData() {
                this.loading = true
                this.$store.dispatch("project/getlistWithPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageIndex,
                    search: this.search,
                    projectId: this.projectId,
                    progressStart:this.progressStart,
                    progressEnd:this.progressEnd
                }).then(response => {
                    this.loading = false
                    this.tableData = response.data.data
                    this.total = response.data.total

                    if (response.data.data && response.data.data.length > 0) {
                        let datas = response.data.data
                        for (let i = 0; i < datas.length; i++) {
                            let data = datas[i]
                            if (data.joinUsersJSON) {
                                data.joinUsers = JSON.parse(data.joinUsersJSON)
                            }
                        }
                    }
                })
            },
            onCurrentChange(page) {
                this.pageIndex = page
                this.loadData()
            },
            confirm() {
                if (this.editItem.isAdd) {
                    this.createProject()
                } else {
                    this.saveProject()
                }
            },
            saveProject() {
                if (this.check()) {
                    this.$store.dispatch("project/saveProject", this.buildSubmitData())
                        .then(success => {
                            this.$message({
                                message: success.data.message,
                                type: 'success'
                            })
                            this.editItem.visible = false
                            this.editItem.data = {}
                            this.loadData()
                        })
                }
            },
            createProject() {
                if (this.check()) {
                    this.$store.dispatch("project/createProject", this.buildSubmitData())
                        .then(success => {
                            this.$message({
                                message: success.data.message,
                                type: 'success'
                            })
                            this.editItem.visible = false
                            this.editItem.data = {}
                            this.loadData()
                        })
                }
            },
            buildSubmitData() {
                let data = {project: {}, upm: {}, otherCost: ''}
                data.project = this.editItem.data
                data.project.customerName = this.editItem.customerList.find(v =>
                    v.id == this.editItem.data.customerId).customer

                data.upm = this.editItem.joinUsers
                data.project.joinUsersJSON = JSON.stringify(data.upm)
                data.otherCost = JSON.stringify(this.editItem.otherCost)
                return data
            },
            loadUserList() {
                this.$store.dispatch("employee/getAllUsers")
                    .then(response => {
                        if (response && response.data) {
                            this.editItem.userList = response.data.data
                        }
                    })
            },
            loadAllPorject() {
                this.$store.dispatch("project/getAllProject")
                    .then(response => {
                        if (response && response.data) {
                            this.projects = response.data.data
                        }
                    })
            },
            handleJoinData() {
                this.pushNewItemToJoinUserData()
            },
            handleOtherCost() {
                this.pushNewItemToOtherData()
            },
            handleJoinDataDel(index) {
                this.editItem.joinUsers.splice(index, 1)
                if (this.editItem.joinUsers.length > 0) {
                    for (let i = 0; i < this.editItem.joinUsers.length; i++) {
                        this.editItem.joinUsers.index = i
                    }
                }
            },
            handleOtherCostDel(index) {
                this.editItem.otherCost.splice(index, 1)
            },
            calcProjectCost() {
                //重置
                this.editItem.data.predictCost = 0
                this.editItem.data.consumption = 0

                //构建呈现数据源
                if (this.editItem.joinUsers && this.editItem.joinUsers.length > 0) {
                    for (let i = 0; i < this.editItem.joinUsers.length; i++) {
                        let joinUserData = this.editItem.joinUsers[i]
                        if (this.editItem.userList && this.editItem.userList.length > 0) {
                            let user = this.editItem.userList.find(v => v.id == joinUserData.userId)
                            if (user) {
                                this.editItem.data.predictCost += Math.round((this.getSalaryWithUserId(user.id) * joinUserData.initWork))
                            }
                            this.editItem.joinUsers[i].cost = Math.round((this.getSalaryWithUserId(user.id) * joinUserData.initWork))
                            this.editItem.data.consumption += joinUserData.initWork

                            if (joinUserData.initWork > 0) {
                                this.editItem.joinUsers[i].noDateLimit = false
                            } else {
                                this.editItem.joinUsers[i].noDateLimit = true
                            }
                        }
                    }
                }

                if (this.editItem.otherCost && this.editItem.otherCost.length > 0) {
                    for (let i = 0; i < this.editItem.otherCost.length; i++) {
                        let otherCost = this.editItem.otherCost[i]
                        this.editItem.data.predictCost += Math.round(parseFloat(otherCost.cost))
                    }
                }

                //重新绑定数据源
                this.$set(this.editItem.data
                    , 'predictCost', this.editItem.data.predictCost)

            },
            handleChange(value) {
                this.calcProjectCost()
            },
            autoLoadEditJoinUsers() {
                this.initJoinUser()
                this.initOtherCost()
            },
            loadCustomerList() {
                this.$store.dispatch("customer/getAllCustomer")
                    .then(response => {
                        console.log(response)
                        if (response && response.data) {
                            this.editItem.customerList = response.data.data
                        }
                    })
            },
            getSummaries(param) {
                const {columns, data} = param
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计'
                        return;
                    }
                    if (index === 1) {
                        sums[index] = ''
                        return
                    }
                    if (!data.map) {
                        return
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                        if (index == 2) {
                            sums[index] += ' 人天'
                        }
                        if (index == 3) {
                            sums[index] += ' 元'
                        }
                    } else {
                        sums[index] = ''
                    }
                })

                return sums
            },
            getOtherCostSummaries(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    if (index === 1) {
                        sums[index] = ''
                        return;
                    }
                    if (!data.map) {
                        return
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += ' 元';
                    } else {
                        sums[index] = '';
                    }
                });

                return sums;
            },
            loadLevelConfigList() {
                this.$store.dispatch("employee/getAllLevelConfig")
                    .then(response => {
                        this.editItem.levelList = response.data.data
                    });
            },
            getSalaryWithUserId(userId) {
                if (userId > 0) {
                    const user = this.editItem.userList.find(v => v.id == userId)
                    if (user && user.theLevel) {
                        return user.theLevel.dayCost
                    }
                }
                return 0
            },
            appointDateRangeChange(data) {
                this.appointDateRange = data
            },
            realDateRangeChange(data) {
                this.$set(this.editItem.data, 'realDateRange', data)
            },
            loadAllPorject() {
                this.$store.dispatch("project/getAllProject")
                    .then(response => {
                        if (response && response.data) {
                            this.projects = response.data.data
                        }
                    })
            },
            check() {
                if (this.editItem.joinUsers && this.editItem.joinUsers.length > 0) {
                    let temp = []
                    let index = -1
                    for (let i = 0; i < this.editItem.joinUsers.length; i++) {
                        let userId = this.editItem.joinUsers[i].userId
                        if (userId <= 0) {
                            index = i
                        }

                        temp.push(this.editItem.joinUsers[i])
                    }

                    if (index !== -1) {
                        temp.splice(index, 1)
                        //选择了员工组里的3个选项中的一个，不建议再单独选员工
                        if (temp.length > 0) {
                            this.$message({
                                message: '按组选择参与人员，不能再单独选择员工',
                                type: 'error'
                            })
                            return false
                        }
                    }
                }
                return true
            }
        },
        watch: {
            'editItem.joinUsers'(to, from) {
                if (to) {
                    this.calcProjectCost()
                }
            },
            // 'editItem.data.appointCreateTime'(to, from) {
            //     if (to) {
            //         this.editItem.data.appointCreateTime = to
            //     }
            // },
            // 'editItem.data.appointEndTime'(to, from) {
            //     if (to) {
            //         this.editItem.data.appointEndTime = to
            //     }
            // }
            // 'editItem.data.realDateRange'(to, from) {
            //     if (!to) {
            //         return
            //     }
            //     this.editItem.data.realCreateTime = to[0]
            //     this.$set(this.editItem.data, 'realCreateTime', to[0])
            //
            //     this.editItem.data.realEndTime = to[1]
            //     this.$set(this.editItem.data, 'realEndTime', to[1])
            // },

        },
        computed: {
            appointDateRange: {
                get() {
                    return [this.editItem.data.appointCreateTime, this.editItem.data.appointEndTime]
                },
                set(value) {
                    this.editItem.data.appointCreateTime = value[0]
                    this.editItem.data.appointEndTime = value[1]

                    this.$set(this.editItem.data, 'appointCreateTime', value[0])
                    this.$set(this.editItem.data, 'appointEndTime', value[1])
                }
            },
            joinUserOptions() {
                let group1 = {
                    label: '员工组',
                    options: this.editItem.groupList
                }

                let group2 = {
                    label: '员工',
                    options: this.editItem.userList
                }

                return [group1, group2]
            }
        },
        created() {
            this.loadCustomerList()
            this.loadUserList()
            this.loadLevelConfigList()
            this.loadAllPorject()
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped lang="scss">
    .w-100 {
        width: 150px;
    }

    .input-with-select {
        width: 260px !important;
    }

    .filter__action {
        display: flex;
        justify-content: flex-end;
        width: 80%;
        flex-flow: row nowrap;

        .item {
            margin: 10px;

            &.project {
                width: 200px !important;
            }

            &.user {
                width: 150px !important;
            }
        }

        .search-item-progress {
            width: 500px;
            max-height: 56px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            /*border: 1px dashed rgba(100,100,100,.6);*/
            padding: 0px 15px;
            border-radius: 5px;

            .progress-label {
                line-height: 56px;
            }
        }

        .search {
            height: 36px;
            margin: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// projectManage.vue?1e8e330e